import format from "string-template";
import Card from "./Card";

const ACORIS_LOGO_URL =
  "https://acorismutuelles.fr/wp-content/uploads/2025/11/Logo-acoris-mutuelle.svg";

const AcorisEmailTemplate = ({
  lastName,
  firstName,
  translation,
  costs,
  adminPhoneNumber,
  adminEmail,
  adminFirstName,
  adminLastName,
}) => {
  return (
    <div className="quote-template-acoris__main-container">
      <div className="quote-template-acoris__header">
        <img src={ACORIS_LOGO_URL} alt="Acoris Mutuelles" />
      </div>
      <div className="quote-template-acoris__container">
        <div className="quote-template-acoris__content">
          <p>
            {format(translation.HEADER, { firstName, lastName })}
          </p>
          <p>{translation.P1}</p>
          <p>{translation.P2}</p>
        </div>
        <div className="quote-template-acoris__formulas">
          {costs?.map(({ id, insurancePlan, cost, currency }) => (
            <Card
              key={id}
              name={insurancePlan?.name}
              cost={cost}
              currency={currency}
              period={translation.CARD.PER_MONTH}
              perYear={translation.CARD.PER_YEAR}
              link={translation.CARD.LINK}
            />
          ))}
        </div>
        <div className="quote-template-acoris__content quote-template-acoris__content--contact">
          <p
            dangerouslySetInnerHTML={{
              __html: format(translation.P3, {
                phone: adminPhoneNumber,
                email: adminEmail,
              }),
            }}
          />
        </div>
        <div className="quote-template-acoris__content">
          <p>{translation.P4}</p>
          <p>{translation.CLOSING}</p>
        </div>
        <div className="quote-template-acoris__info">
          <p className="quote-template-acoris__info--label">
            {translation.YOUR_ADVISOR}
          </p>
          <p className="quote-template-acoris__info--name">
            {adminFirstName} {adminLastName}
          </p>
          <p>{adminPhoneNumber}</p>
        </div>
      </div>
    </div>
  );
};

export default AcorisEmailTemplate;
